<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tbody
            formArrayName="data"
            *ngFor="let item of formData.controls; let i = index"
            class="optimisation-equipment"
          >
            <tr>
              <td class="margin" style="width: 50%"></td>
              <td class="th-plugin-line--remove" style="text-align: right; width: 50%">
                <i class="material-icons" (click)="remove(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.installation-equipment-info.supplier' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="item.controls.Supplier"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="hidden" name="Supplier" class="ir-form-set" formControlName="Supplier" />
                  <div class="ir-line ir-select th-select" (click)="openSupplierSelector(i)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        item.controls.Supplier.value
                          ? (item.controls.Supplier.value | supplier)
                          : ('plugins.installation-equipment-info.select-supplier' | translate)
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="item.controls.Supplier.value === 1">
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.installation-equipment-info.product-line' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="item.controls.ProductLine"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="hidden" name="ProductLine" class="ir-form-set" formControlName="ProductLine" />
                  <div class="ir-line ir-select th-select" (click)="openProductLinesSelector(i)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span
                        >{{
                          item.controls.ProductLine.value
                            ? (item.controls.ProductLine.value | productline | async)
                            : ('plugins.installation-equipment-info.select-product-line' | translate)
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="item.controls.Supplier.value === 1">
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.installation-equipment-info.equipment-type' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="item.controls.name"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="hidden" name="name" class="ir-form-set" formControlName="name" />
                  <div class="ir-line ir-select th-select" (click)="openModelsSelector(i)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        item.controls.name.value
                          ? item.controls.name.value
                          : ('plugins.installation-equipment-info.select-machine' | translate)
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="item.controls.Supplier.value">
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.installation-equipment-info.serial-number' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <validation-message
                    [validationControl]="item.controls.SerialNumber"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input
                    name="SerialNumber"
                    required
                    minlength="1"
                    class="ir-form-set"
                    type="text"
                    formControlName="SerialNumber"
                  />
                </div>
              </td>
            </tr>
          </tbody>
          <tr class="th-plugin-line--add">
            <td colspan="2">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal (modalOutput)="selectModelsMenu($event)" (modalClosed)="onClose()" #modelsModal></modal>
<modal (modalOutput)="selectSupplierMenu($event)" (modalClosed)="onSupplierMenuClose()" #supplierModal></modal>
<modal
  (modalOutput)="selectProductLinesMenu($event)"
  (modalClosed)="onProductLinesMenuClose($event)"
  #productLinesModal
></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
